import type { IReviewItem } from '@sravni/react-seo';

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import type { ReviewsListParams } from '../../__generated__/reviews/reviewsApiTypes';
import { getReviews } from '../../services/reviews';
import type { GlobalState } from '../index';

export interface IState {
  list: IReviewItem[];
  isLoading: boolean;
}

const initialState: IState = {
  list: null,
  isLoading: false,
};

export const fetchReviews = createAsyncThunk<
  IReviewItem[],
  ReviewsListParams,
  {
    state: GlobalState;
  }
>('reviews/fetch', async (params) => getReviews(params));

const reviewsSlice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchReviews.fulfilled, (state, { payload }) => {
      state.list = payload;
      state.isLoading = false;
    });
    builder.addCase(fetchReviews.rejected, (state) => {
      state.list = [];
      state.isLoading = false;
    });
    builder.addCase(fetchReviews.pending, (state) => {
      state.isLoading = true;
    });
  },
});

const { reducer } = reviewsSlice;
export default reducer;
